/**
 * ABON-V2-P1: подписи остатка визитов и срока абонемента (admin).
 */

export function visitsRemainingOf(row) {
  if (!row) return null;
  const v = row.visitsRemaining != null ? row.visitsRemaining : row.VisitsRemaining;
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

export function visitLimitOf(row) {
  if (!row) return null;
  const v = row.visitLimit != null ? row.visitLimit : row.VisitLimit;
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

/** «3 / 8», «0 / 8», «безлимит» */
export function formatVisitBalance(row) {
  const rem = visitsRemainingOf(row);
  const lim = visitLimitOf(row);
  if (rem == null && lim == null) return 'безлимит';
  if (lim != null && rem != null) return `${rem} / ${lim}`;
  if (rem != null) return String(rem);
  if (lim != null) return `— / ${lim}`;
  return 'безлимит';
}

/**
 * @returns {{ label: string, tone: 'ok'|'warn'|'danger'|'muted' }}
 */
export function abonementExpiryBadge(row, { now = new Date() } = {}) {
  const toRaw = row && (row.dateTo != null ? row.dateTo : row.DateTo);
  if (!toRaw) return { label: '', tone: 'muted' };
  const end = new Date(toRaw);
  if (Number.isNaN(end.getTime())) return { label: '', tone: 'muted' };
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.round((endDay - today) / 86400000);
  const rem = visitsRemainingOf(row);

  if (diffDays < 0) return { label: 'просрочен', tone: 'danger' };
  if (rem === 0) return { label: 'визиты закончились', tone: 'danger' };
  if (diffDays === 0) return { label: 'истекает сегодня', tone: 'warn' };
  if (diffDays <= 7) return { label: `истекает через ${diffDays} дн.`, tone: 'warn' };
  return { label: `ещё ${diffDays} дн.`, tone: 'ok' };
}

export const ABONEMENT_EXPIRY_COLORS = {
  ok: '#2e7d32',
  warn: '#ed6c02',
  danger: '#d32f2f',
  muted: '#757575',
};
